module.exports = __webpack_public_path__ + "img/SA.a74ab19a.png";